import { render, staticRenderFns } from "./formGroupView.vue?vue&type=template&id=4c6dc8a6&scoped=true&"
import script from "./formGroupView.vue?vue&type=script&lang=js&"
export * from "./formGroupView.vue?vue&type=script&lang=js&"
import style0 from "./formGroupView.vue?vue&type=style&index=0&id=4c6dc8a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6dc8a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\新动态表单\\hj-dynamic-form-plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6dc8a6')) {
      api.createRecord('4c6dc8a6', component.options)
    } else {
      api.reload('4c6dc8a6', component.options)
    }
    module.hot.accept("./formGroupView.vue?vue&type=template&id=4c6dc8a6&scoped=true&", function () {
      api.rerender('4c6dc8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formGroupView/src/formGroupView.vue"
export default component.exports